/* eslint-disable max-lines */
import type * as en from "./en"
import type { TranslationResource } from "./types"

/* cSpell:disable */

const utilityCompanyAdminTable: typeof en.utilityCompanyAdminTable = {
  website: `Sitio web`,
  name: `Nombre`,
  offeringType: `Tipo de oferta`,
  serviceTypes: `Tipos de servicio`,
  ownership: `Propiedad`,
}

const regressionWarnings: typeof en.regressionWarnings = {
  regressionWarning_EdgeDesignation: `Los metadatos se restablecerán en cualquier cara del techo que modifique.`,
  // regressionWarning_PanelPlacement: `All panels will be removed.`,
  // regressionWarning_PanelActivation: `Active panels will be reset.`,
}

const toolDescriptions: typeof en.toolDescriptions = {
  drawToolDesc: `Dibuja líneas de una cara de techo.`,
  edgeDesignatorDesc: `Designar un borde de una cara de cubierta.`,
  eraseToolDesc: `Borrar un objeto.`,
  groundMountToolDesc: `Úselo para montar paneles en el suelo`,
  panelActivatorDesc: `Haga clic para habilitar o deshabilitar los paneles seleccionados.`,
  rulerDesc: `Mide la distancia entre dos puntos.`,
  selectDesc: `Haga clic para interactuar con un objeto (techo, borde, panel).`,
  panelCreatorLandscapeDesc: `Añadir paneles orientadas a la horizontal a su sistema.`,
  panelCreatorPortraitDesc: `Añadir paneles orientadas a la vertical a su sistema.`,
  panelEraserDesc: `Borrar paneles.`,
  treeToolDesc: `Úsalo para crear árboles.`,
  panDesc: `Mover la vista del mapa.`,
  moveDesc: `Mover todos los elementos `,
}

const toolLabels: typeof en.toolLabels = {
  draw: `Dibujar`,
  edgeDesignator: `Designar bordes`,
  erase: `Borrar`,
  groundMount: `Montar en el suelo`,
  panelActivator: `Activar paneles`,
  panelCreatorLandscape: `Añadir paneles horizontales`,
  panelCreatorPortrait: `Añadir paneles verticales`,
  panelEraser: `Borrar paneles`,
  ruler: `Regla`,
  select: `Seleccionar`,
  trees: `Árboles`,
  pan: `Mover`,
  move: `Reubicar Elementos`,
}

export const poisonMessages: typeof en.poisonMessages = {
  poisonedQuote: `Algo salió mal al generar una cotización. Prueba a cambiar el diseño o el préstamo del producto.`,
  poisonedEstimate: `Algo salió mal al estimar la producción para un área de instalación. Prueba a cambiar el diseño.`,
  poisonedSavings: `Algo salió mal al proyectar ahorros. Prueba a cambiar el diseño.`,
}

export const brochureSections = {
  "monthlyBill": `Factura Mensual`,
  "processSummary": `Resumen del Proceso`,

  // finance section
  "paymentSummaryDes": `tu resumen financiero`,
  "paymentSummaryHeader": `Opciones de Pago Flexibles`,
  "yourPayments": `Tus pagos`,
  "monthlyPayment": `Pago mensual`,
  "estimatedVppMonthlyBenefit": `Beneficio mensual estimado de VPP:`,
  "netEffectivePayment": `Pago neto efectivo:`,
  "vppPaymentsEstimatedVariable": `Los pagos de VPP son estimados y variables`,
  "financialBreakdown": `Desglose financiero`,
  "startingSystemPrice": `Precio inicial del sistema`,
  "systemPrice": `Precio del sistema`,
  "propelDiscount": `Descuento Propel`,
  "discount": `Descuento`,
  "participateNetAmountDue": `Monto neto a pagar de Participate`,
  "yourFinancedAmount": `Monto financiado`,
  "yourFinancedAmountNote": `Este es el monto que financiará después de aplicar su descuento Propel.`,
  "concertFinancingFinePrint": `A diferencia de las facturas de servicios públicos que suben cada año, su pago de Propel se mantiene igual. Así es como funciona: su descuento Propel se aplica de inmediato al firmar, reduciendo el valor total del contrato antes de financiar un solo dólar. Su préstamo se basa en ese monto menor, lo que le brinda un pago mensual fijo a una tasa competitiva durante todo el plazo de {{term}} años. Sin escalador. Sin sorpresas en la tasa. Solo costos de energía predecibles y ahorros a largo plazo. Los términos finales se detallarán en su contrato de préstamo.`,
  "applyIncentives": `Aplicar incentivos al préstamo`,
  "incentivesAppliedToLoanNote": `Las casillas marcadas indican que los incentivos se están aplicando al préstamo.`,
  "incentiveFirstYearValueFootnote": `* El valor del incentivo representa únicamente el valor del primer año. Los valores de los años posteriores se aplicarán en efectivo.`,
  "energyRebatesDisclaimerTitle": `Créditos Fiscales y Reembolsos de Energía.`,
  "energyRebatesDisclaimerContent": `A petición suya, Powur le brindará el apoyo y la documentación razonables que puedan ser necesarios en relación con su solicitud de cualquier reembolso de energía o crédito fiscal federal, estatal o local disponible en relación con la instalación del Sistema Solar; sin embargo, POWUR NO HACE NINGUNA DECLARACIÓN, GARANTÍA NI PROMESA DE QUE USTED CALIFICARÁ PARA U OBTENDRÁ ALGÚN REEMBOLSO DE ENERGÍA O CRÉDITO FISCAL FEDERAL, ESTATAL O LOCAL EN RELACIÓN CON EL SISTEMA SOLAR. Se le recomienda consultar a profesionales legales y/o contables sobre su elegibilidad y para obtener asistencia con cualquier reembolso de energía o crédito fiscal. Powur no es responsable de los cambios en la disponibilidad o en los incentivos de ningún programa federal, estatal o local de reembolso de energía o crédito fiscal.`,
  "financeOption": `Opción de financiamiento`,
  "financePartner.goodleap": `GoodLeap`,
  "financePartner.sungage": `Sungage`,
  "financePartner.enfin": `Enfin`,
  "financePartner.mosaic": `Mosaic`,
  "financePartner.sunlightFinancial": `Sunlight Financial`,
  "financePartner.lightReach": `LightReach`,
  "financePartner.concertFinancial": `Concert Financial`,
  "financePartner.concertBattery": `Concert (solo batería)`,
  "financePartner.creditHuman": `Credit Human`,
  "financePartner.creditHumanBattery": `Credit Human (solo batería)`,
  "financePartner.sungageBattery": `Sungage (solo batería)`,
  "financePartner.lightReachBattery": `LightReach (solo batería)`,
  "financePartnerFundingGroup.goodleapTpo": `Goodleap - TPO`,
  "financePartnerFundingGroup.goodleapLoan": `Goodleap - Loan`,
  "financePartnerFundingGroup.enfinTpo": `Enfin - TPO`,
  "financePartnerFundingGroup.sungageBrightStar": `Sungage - BrightStar`,
  "financePartnerFundingGroup.sungageSunriseEscalator": `Sungage - Sunrise Escalator`,
  "financePartnerFundingGroup.sungageBatteryBrightStart": `Sungage - BrightStart (solo batería)`,
  "financePartnerFundingGroup.sungageBatterySunrise": `Sungage - Sunrise (solo batería)`,

  // environmental impact section
  "environmentalImpact": `Impacto Ambiental`,
  "environmentalAndHomeValueImpact": `Impacto Ambiental y en el Valor del Hogar`,
  "co2Label": `Toneladas métricas de CO2 compensadas en 25 años`,
  "treesLabel": `Número de árboles equivalentes plantados`,
  "valueLabel": `Valor estimado agregado a su hogar*`,
}

const systemSummarySlide = {
  moduleType: `Tipo de Módulo`,
  numberOfPanels: `Número de Paneles`,
}

const monthlyBillSlideDisclaimers = {
  postSolarUtilityCalculationDisclaimer: `(GOOGLE TRANSLATED) Aviso legal: Los ahorros estimados a 25 años y las facturas posteriores a la instalación solar se basan en el autoconsumo de la batería y pueden variar debido a los hábitos de consumo individuales y la posible degradación de la batería con el tiempo.`,
  monthlyBillDisclaimer: `Las facturas de servicios públicos y el incremento de tarifas son estimaciones basadas en datos históricos, y las tarifas reales pueden variar. Esta propuesta proporciona estimaciones no vinculantes. Aunque nos esforzamos por la precisión, no se proporcionan garantías ni garantías con respecto a los aumentos de tarifas, costos de servicios públicos o la capacidad del sistema solar para ahorrar en facturas de electricidad.`,
  deregulatedRatesNotice: `En mercados eléctricos desregulados, la propuesta utiliza una tarifa contratada estimada para las facturas de servicios públicos promedio. Esta tarifa puede cambiar con las condiciones del mercado, decisiones del proveedor o cambios en los términos contratados.`,
}

const utilitySavingsSlides: typeof en.utilitySavingsSlides = {
  doNothing: `No hacer nada`,
  goSolar: `Cambiar a solar`,
  dialYear: `Año`,
  dialYears: `Años`,
  dialSavings: `Ahorro en 25 años`,
  averageUtilityBill: `Factura eléctrica promedio`,
  newAverageUtilityBill: `Nueva factura eléctrica promedio`,
  solarPayment: `Pago solar`,
  billEnergy: `Energía`,
  billFixed: `Fijo`,
  billTotal: `Total`,
  recalculatingUtilitySavings: `Recalculando el ahorro en servicios públicos`,
  effectiveUtilityRate: `Tarifa efectiva de servicios públicos:`,
  annualUtilityIncrease: `Aumento anual de servicios públicos:`,
  annualEnergyConsumption: `Consumo anual de energía:`,
  yearOneSolarRate: `Tarifa solar del año 1`,
  averageSolarRate: `Tarifa solar promedio:`,
  annualSolarIncrease: `Aumento solar anual:`,
  annualSolarProduction: `Producción solar anual:`,
  perMonth: `/mes`,
  currentAverageUtility: `Factura promedio actual`,
  currentAverageUtilityWithSolar: `Factura promedio actual con energía solar`,
  averageUtilityIn25Years: `Factura promedio en 25 años`,
  averageUtilityWithSolarIn25Years: `Factura promedio con energía solar en 25 años`,
  costOfDoingNothingOver25Years: `Costo de no hacer nada en 25 años`,
  savingsWithSolarOver25Years: `Ahorro con energía solar en 25 años`,
  graphYears: `Años`,
  avgMonthlyPayment: `Pago mensual prom.`,
  graphCostWithSolar: `Costo con energía solar`,
  graphSolarSystemCost: `Costo del sistema solar`,
  graphCostWithoutSolar: `Costo sin energía solar`,
}

const shareProposalStep = {
  presentationProductionUnavailable: `Las estimaciones de producción no están disponibles para esta presentación. Pide a tu asesor una propuesta actualizada.`,
  presentationSavingsUnavailable: `El ahorro de servicios públicos no está disponible para esta presentación. Pídele a tu vendedor una propuesta actualizada.`,
  publicPresentationDescription: `Cualquier persona con este enlace puede ver la presentación de la propuesta sin iniciar sesión. El enlace no permite modificar la propuesta.`,
  publicPresentationLink: `Enlace público de la presentación`,
  loadingPresentationLink: `Cargando enlace de la presentación…`,
  presentationLinkError: `No se pudo cargar o crear el enlace. Inténtalo de nuevo.`,
  presentationLinkExpires: `El enlace vence el {{date}}.`,
  presentationLinkCopied: `Copiado`,
  copyPresentationLink: `Copiar enlace`,
  openPresentation: `Abrir presentación`,
  presentationLinkCopyError: `No se pudo copiar automáticamente. Selecciona y copia el enlace de arriba.`,
  creatingPresentationLink: `Creando enlace…`,
  createPresentationLink: `Crear enlace público`,

  pleasePublish: `Por favor publique su propuesta para compartir.`,
}

const es: { translation: TranslationResource } = {
  translation: {
    jan: `Enero`,
    feb: `Feb`,
    mar: `Marzo`,
    apr: `Abr`,
    may: `Mayo`,
    jun: `Jun`,
    jul: `Jul`,
    aug: `Agosto`,
    sep: `Set`,
    oct: `Oct`,
    nov: `Nov`,
    dec: `Dic`,

    activeKey: `Clave Activa`,
    allPermissions: `Todos los permisos`,
    all: `Todos`,
    concertUsers: `Concert`,
    currentKey: `Clave actual`,
    filterByPermission: `Filtrar por permiso`,
    licenseExists: `Licencia existente`,
    loadingConcertUsers: `Cargando usuarios de Concert…`,
    loadingIntegration: `Cargando integración…`,
    loadingServiceIntegrations: `Cargando integraciones de servicio…`,
    loadingUser: `Cargando usuario…`,
    loadingUsers: `Cargando usuarios…`,
    noConcertUsersFound: `No se encontraron usuarios de Concert.`,
    noServiceIntegrationsFound: `No se encontraron integraciones de servicio.`,
    noUsersFound: `No se encontraron usuarios.`,
    onboardingCompleted: `Incorporación completada`,
    permissionsUnavailable: `No se pudieron cargar los filtros de permisos. Inténtalo de nuevo.`,
    powurUsers: `Usuarios de Powur`,
    searchPermissions: `Buscar permisos`,
    unableCreateIntegration: `No se pudo crear esta integración. Inténtalo de nuevo.`,
    unableLoadIntegration: `No se pudo cargar esta integración. Inténtalo de nuevo.`,
    unableLoadServiceIntegrations: `No se pudieron cargar las integraciones de servicio. Inténtalo de nuevo.`,
    unableLoadUser: `No se pudo cargar este usuario. Inténtalo de nuevo.`,
    unableLoadUsers: `No se pudieron cargar los usuarios. Inténtalo de nuevo.`,
    unableSaveIntegration: `No se pudieron guardar estos cambios. Inténtalo de nuevo.`,
    unableUpdateUser: `No se pudo actualizar este usuario. Inténtalo de nuevo.`,
    users: `Usuarios`,
    add: `Añadir`,
    adder: `Sumadora`,
    adders: `Sumadores`,
    systemPricingOverview: `Resumen de sumadores`,
    systemPricingOverviewDesc: `Resumen de sumadores seleccionados para este proyecto.`,
    addIntegration: `Nueva Integración`,
    address: `Dirección`,
    addressSearchPlaceholder: `Buscar tu dirección...`,
    admin: `Administrador`,
    allAdders: `Todos los sumadores`,
    allPanels: `Todos`,
    annualCost: `Costo Anual de Servicios Públicos ($)`,
    annualConsumption: `Consumo Anual`,
    annualProduction: `Producción Anual`,
    annualUsage: `Uso Anual`,
    annualUsageDesc: `Sé cuánta energía se usa en un año.`,
    annualUsageProfile: `Perfil de Uso Anual`,
    annualUsageProfileDesc: `Esta estimación de uso anual se generó utilizando las lecturas que proporcionó.`,
    apiKey: `Clave API`,
    apiKeys: `Claves API`,
    applyDefault: `Aplicar por Defecto`,
    applyToLoan: `Aplicar al Préstamo`,
    approximateAnnualUsage: `Uso Anual Aproximado`,
    autoPlacePanels: `Paneles de ubicación automática`,
    averageMonthCost: `Costo Promedio Mensual`,
    averageMonthCostProfileDesc: `Esta estimación del costo mensual promedio se generó utilizando las lecturas que proporcionó.`,
    averageMonthlyCost: `Costo Promedio Mensual`,
    azimuth: `Azimut`,
    //TODO translate
    backToPowur: `Back to Powur.com`,
    backToProposal: `Regresar a la propuesta`,
    backToQueue: `Regresar a la cola`,
    batteryCompatibility: `Necesita compatibilidad con baterías?`,
    batteryInstallation: `Instalación de Baterías`,
    both: `Ambos`,
    bothMountsDesc: `Poseer ambos montajes de sistema solar puede ser beneficioso para superficies más pequeñas. Esta selección es óptima para propietarios que quieren maximizar el rendimiento solar.`,
    browseFiles: `Buscar Archivos`,
    cancel: `Cancelar`,
    cancellationFees: `Cargos de Cancelación`,
    cashPrice: `Precio en Efectivo`,
    category: `Categoría`,
    chooseAModuleToSeeDetails: `Selecciona un módulo para ver sus detalles.`,
    clear: `Claro`,
    consumption: `Consumo`,
    contactEmail: `Correo Electrónico de Contacto`,
    contactName: `Nombre de Contacto`,
    contained: `Contenido`,
    continue: `Continuar`,
    continueConfirmDesc: `Si continúa, se perderán todos los cambios no guardados.`,
    complete: `Completar`,
    completeAndNext: `Completar y Siguiente`,
    contract: `Contrato`,
    contractSigning: `Firma de Contrato`,
    contractStatus: `Estado del Contrato`,
    contractStatusDesc: `Estado de los documentos de contrato.`,
    contractedRate: `Tarifa Contratada ($/kWh)`,
    monthlyBillInput: `Factura Mensual ($)`,
    monthlyBillBelowMinimum: `La Factura Mensual no puede ser inferior a {{minimum}}.`,
    copyLink: `Copiar Enlace`,
    createLink: `Crear Enlace`,
    customerName: `Nombre del Cliente`,
    customSavingsReportFor: `Reporte de Ahorros Personalizado para`,
    dateCreated: `Fecha de Creación`,
    deactivate: `Desactivar`,
    dealerFee: `Comisión de Distribuidor`,
    dealerFeePercentage: `% de Comisión de Distribuidor`,
    default: `Defecto`,
    defaultStatus: `Estado por Defecto`,
    design: `Diseño`,
    designInProgressMessage: `Un diseñador de Vision está trabajando en este diseño. Una vez que esté completo, puede utilizar la fase de activación del panel para finalizar el diseño y el tamaño del sistema.`,
    designInProgressTitle: `Diseño en Progreso`,
    designPreventionTitle: `La edición no es posible en este momento`,
    designPreventionDesc: `Hasta que el usuario termine de editar, no puede editar el diseño actual. Las actualizaciones no se guardarán en el servidor.`,
    retiredImageryUnavailableTitle: `Imagen guardada de Bing no disponible`,
    retiredImageryUnavailableDescription: `Este diseño usa una imagen guardada de Bing que ya no se puede cargar, y las imágenes de Bing ya no están disponibles. La edición del diseño está en pausa para que los paneles no se editen sobre otro fondo. Elija una fuente de imagen compatible para continuar.`,
    retiredImageryGoBack: `Regresar`,
    retiredImageryTryAgain: `Intentar de nuevo`,
    retiredImageryNoSupportedImage: `Todavía no hay una imagen compatible disponible para este sitio.`,
    siteImageUnavailableTitle: `Imagen del sitio no disponible`,
    siteImageUnavailableDescription: `No se pudo cargar la imagen aérea guardada de este diseño. La distribución de los paneles se muestra sin ella.`,
    retiredImageryReplacementUnavailableTitle: `Imagen seleccionada no disponible`,
    retiredImageryReplacementUnavailableDescription: `No se pudo cargar la imagen seleccionada. La edición del diseño sigue en pausa para que los paneles no se editen sobre un fondo faltante. Elija otra fuente de imagen compatible.`,
    replaceImageKeepsLayout: `¿Usar esta imagen como fondo? La distribución actual de los paneles se conserva tal como está. Verifique que coincida con la nueva imagen antes de guardar.`,
    designWillBeReset: `ADVERTENCIA: Cambiar la imagen restablecerá su diseño actual y eliminará permanentemente todo el trabajo anterior. Por favor confirme si desea continuar.`,
    designSelection: `Selección de Diseño`,
    disclosures: `Declaraciones`,
    done: `Hecho`,
    downPayment: `Pago Inicial`,
    dragAndDropYourFilesHere: `Arrastra y suelta tus archivos aquí`,
    edit: `Editar`,
    editLoanProduct: `Editar Producto de Préstamo`,
    editUser: `Editar Usuario`,
    electrical: `Eléctrico`,
    email: `Email`,
    energyConsumption: `Consumo de Energía`,
    energyConsumptionDesc: `Ingrese o vea el consumo histórico de energía.`,
    energyEfficiencyKitRebate: `Reembolso del Kit de Eficiencia Energética`,
    energyOffset: `Compensación de Energía`,
    engineering: `Ingeniería`,
    enterTicketUrl: `Ingrese la URL del ticket`,
    equipmentSelection: `Selección de equipo`,
    equipment: `Equipo`,
    eraseLayout: `Borrar diseño`,
    escalationPercent: `esc %`,
    exportSavingsToCSV: `Exportar proyección de ahorro a csv`,
    solarPdfGenerating: `Generando PDF`,
    solarPdfFailed: `No se pudo generar el PDF. Inténtalo de nuevo.`,
    solarPdfPopupBlocked: `Permite las ventanas emergentes de este sitio y vuelve a exportar.`,
    exportToPdf: `Exportar a PDF`,
    fee: `Cargo`,
    financing: `Financiamiento`,
    financingSelection: `Selección de Financiación`,
    financialProduct: `Producto Financiero`,
    financingType: `opciones de financiamiento`,
    productOffering: `Oferta de Producto`,
    firstName: `Primer Nombre`,
    freight: `Transporte`,
    fundingSelectionDesc: `Seleccione el producto de financiamiento para ofrecer al propietario.`,
    generators: `Generadores`,
    geocodeVerification: `Verificación de geocodificación`,
    geocodeVerificationDesc: `Puede mover el pin en el mapa para actualizar el código geográfico.`,
    getProposal: `Obtener Propuesta`,
    groundMountDesc: `Montajes en tierra ocupan más espacio, pero son más fáciles de acceder para instalación y reparación. Además, les da mayor control sobre la orientación de su arreglo para maximizar la producción.`,
    greenbuttonData: `Greenbutton Data`,
    home: `Hogar`,
    homeAndUtilityInfo: `Sobre el Hogar y los Servicios Públicos`,
    homeownerInformation: `Información del Propietario`,
    homeownerInformationDesc: `Nombre, dirección, email, número de teléfono`,
    siteInformation: `Información del Sitio`,
    siteInformationDesc: `Propietario, dirección y elegibilidad para incentivos`,
    homeownerRebate: `Reembolso de propietario`,
    imagery: `Imágenes`,
    incentives: `Incentivos`,
    incentiveSource: `Fuente de Incentivo`,
    installArea: `Área de Instalación`,
    integrationDetails: `Detalles de Integración`,
    integrationName: `Nombre de integración`,
    intersecting: `Parcial`,
    inverter: `Inversor`,
    inverterBrand: `Marca de Inversor`,
    inverterManufacturer: `Fabricante de Inversor`,
    inverterModel: `Modelo de Inversor`,
    inverterModel2: `Modelo de Inversor Secundario (opcional)`,
    inverterSelection: `Selección de Inversor`,
    inverterSelectionDesc: `Seleccione el tipo de inversor que le gustaría para este sistema`,
    issuedTo: `Emitida a`,
    issueNewKey: `Nueva Clave`,
    isPaidAsLumpSum: `¿Se paga como suma global?`,
    isSungageRebate: `¿Es un reembolso de Sungage?`,
    jurisdiction: `Jurisdicción`,
    keyCount_plural: `{{count}} Claves`,
    keyCount: `{{count}} Clave`,
    keyFeatures: `Características Clave`,
    lastName: `Apellido`,
    lastRequestAt: `Última solicitud en`,
    leadAcquisition: `Adquisición de Leads`,
    lifetimeUsage: `Uso de por vida`,
    lifetimeUsageCount_plural: `{{count}} solicitudes`,
    lifetimeUsageCount: `{{count}} solicitud`,
    linkCopied: `Enlace copiado`,
    loading: `Cargando...`,
    logout: `Logout`,
    message: `Mensaje`,
    messageForHomeowner: `Mensaje para el Propietario`,
    meter: `Medidor`,
    miscellaneous: `Misceláneo`,
    module: `Módulo`,
    modules: `Módulos`,
    moduleSelection: `Selección de módulo`,
    moduleSelectionDesc: `Utilice el módulo sugerido o seleccione el suyo en la lista desplegable a continuación.`,
    moduleInverterCompatibilityWarningTitle: `Selección de equipo incompatible`,
    moduleInverterCompatibilityWarning: `{{module}} no es compatible con {{inverters}}. Seleccione un inversor compatible para continuar.`,
    auroraModuleInverterCompatibilityWarning: `{{module}} no es compatible con {{inverters}}. Actualice este equipo en Aurora y luego actualice el Diseño en Vision.`,
    noCompatibleInverterManufacturerWarningTitle: `No hay un inversor compatible disponible`,
    noCompatibleInverterManufacturerWarning: `Ningún inversor de {{manufacturer}} es compatible con {{module}}. Seleccione un Módulo o fabricante de Inversor diferente para continuar.`,
    moduleUnavailableWarningTitle: `Módulo no disponible`,
    moduleUnavailableWarning: `{{module}} ya no está disponible. Seleccione un módulo actual antes de elegir un inversor.`,
    moduleMismatchSummary: `Los paneles solares seleccionados no coinciden con los paneles solares utilizados. Proceda con precaución. Si es necesario, envíe una solicitud de revisión al Equipo de Diseño Vision para rediseñar utilizando los nuevos paneles solares.`,
    moduleMismatchProposal: `Panel en Propuesta:`,
    moduleMismatchDesign: `Panel en Diseño:`,
    months: `Meses`,
    monthlyConsumption: `Consumo Mensual`,
    monthlyConsumptionDesc: `Sé el consumo durante varios meses`,
    monthlyConsumptionProfile: `Perfil de Consumo Mensual`,
    monthlyConsumptionProfileDesc: `Esta estimación de consumo mensual se generó utilizando las lecturas que proporcionó.`,
    mount: `Montar`,
    mounting: `Montaje`,
    mountSelection: `Selección de montaje`,
    mountSelectionDesc: `Seleccione si desea que su sistema esté en el techo de su casa, en el suelo o en ambos.`,
    mountingType: `Tipo de Montaje`,
    mustBeAValidUrl: `Debe ser una URL válida`,
    needsMoreFeedback: `Necesita ás retroalimentación`,
    newCustomerIncentive: `Incentivo Para Nuevos Clientes`,
    newIntegration: `Agregar una nueva integración`,
    next: `Siguiente`,
    no: `No`,
    noEquipmentSelected: `Ningún equipo seleccionado.`,
    noKey: `Sin clave`,
    noKeys: `Sin claves anteriores`,
    nonPrimaryEquipmentSelection: {
      part1: `Por favor seleccione el tipo de`,
      part2: `que le gustaría para este sistema.`,
    },
    notAPowurUser: `No es un Usuario de Powur`,
    numberOfDesigns: `# de Diseños`,
    offset: `Desplazamiento`,
    or: `o`,
    orientation: `Orientación`,
    page: `Página`,
    panels: `Paneles`,
    panelsAutoPlaced: `Los paneles se colocaron automáticamente`,
    panelCount: `Numero de Paneles`,
    phoneNumber: `Número de Teléfono`,
    postSolarPowerInstallation: `Despues de Instalación de Energía Solar`,
    postSolarPowerInstallationRep: `Despues de Instalación de Energía Solar (REP)`,
    powurMargin: `% de margen de Powur`,
    powurOsId: `ID de Powur OS`,
    powurProjectId: `ID de Proyecto de Powur`,
    powurUser: `Usuario de Powur`,
    preSolarPowerInstallation: `Antes de Instalación de Energía Solar`,
    preSolarPowerInstallationRep: `Antes de Instalación de Energía Solar (REP)`,
    previous: `Anterior`,
    price: `Precio`,
    pricing: `Precios`,
    primaryContact: `Primer Contacto`,
    production: `Producción`,
    productName: `Nombre del Producto`,
    productivity: `Productividad`,
    projectManagement: `Gestión de Proyectos`,
    projectService: `Servicio de Proyecto`,
    projectSetup: `Configuración de Proyecto`,
    projectSetupMessage: `Por favor, configura tu proyecto.`,
    proposalId: `ID de la Propuesta`,
    proposalName: `Nombre de la Propuesta`,
    proposalType: `Tipo de propuesta`,
    batteryOnly: `Solo batería`,
    solar: `Solar`,
    proposals: `Propuestas`,
    proposalSettings: `Configuración de la propuesta`,
    provider: `Proveedor`,
    providerName: `Nombre del Proveedor`,
    powurOsLoanId: `PowurOS Loan ID`,
    publish: `Publicar`,
    rate: `APR`,
    ratePlan: `Plan de Tarifa`,
    rebates: `Reembolsos`,
    reset: `Reiniciar`,
    resetConfirmation: `¿Estás seguro de que deseas reiniciar el diseño?`,
    resetImage: `Reiniciar Imagen`,
    roofing: `Techo`,
    roofMount: `Montaje en Techo`,
    roofMountDesc: `Los montajes de techo son menos costosos porque utilizan su estructura de techo existente como base. También ocupan menos espacio en su propiedad.`,
    roofWork: `Trabajo en el Techo`,
    roofWorkRebate: `Reembolso de Trabajo en el Techo`,
    save: `Guardar`,
    saving: `Guardando`,
    saved: `Guardado`,
    search: `BÚSQUEDA`,
    searchUsersPlaceholder: `Buscar por nombre o correo electrónico...`,
    selectAdders: `Selección de Sumadores`,
    selectAddersDesc: `Seleccionar de la lista de sumadores para este proyecto`,
    selectIncentives: `Selccione Incentivos`,
    vppIncentives: `Incentivos VPP`,
    selectIncentivesDesc: `El incentivo para nuevos clientes es un reembolso opcional de Powur para el propietario. El incentivo está valorado en 12 veces el pago mensual inicial del préstamo. Si se selecciona una opción GoodLeap Flex Pay de 18 o 36 meses, el incentivo para nuevos clientes cubrirá 18 o 36 meses, respectivamente.`,
    selectionOverview: `Selección de Resumen`,
    setbacks: `Requisitos de Retroceso`,
    shading: `Sombreado`,
    share: `Cuota`,
    shareDesc: `Publica y comparte esta propuesta`,
    show: `Mostrar`,
    skip: `Omitir`,
    slope: `Pendiente`,
    start: `Iniciar`,
    status: `Estado`,
    statesActive: `Estados Activo`,
    storage: `Almacenamiento`,
    storageSelection: `Selección de Almacenamiento`,
    storageSelectionDesc: `Seleccione el tipo de almacenamiento que le gustaría para este sistema.`,
    summaryListDesc: `Todo lo que necesitas para llevar este proyecto a la instalación`,
    submit: `Enviar`,
    sunroofMessage: `El sombreado de Sunroof se calculará después de colocar los paneles.`,
    switchedOff: `Apagado`,
    switchedOn: `Encendido`,
    systemDesign: `Diseño de Sistemas`,
    systemDesignDesc: `Diseñe el sistema para su propietario.`,
    auroraDesignDesignSection: `Diseño`,
    auroraDesignDetailsTab: `Detalles`,
    auroraDesignRefreshDetailsHide: `Ocultar detalles`,
    auroraDesignRefreshDetailsShow: `¿Qué cambia al actualizar?`,
    auroraDesignRefreshSummary: `Actualizar puede borrar las selecciones de financiamiento.`,
    auroraDesignSections: `Secciones del diseño de Aurora`,
    auroraDesignSyncSection: `Sincronización`,
    auroraSyncBlurbCompleted: `La última sincronización desde Aurora se completó.`,
    auroraSyncBlurbInProgress: `Obteniendo el diseño más reciente desde Aurora.`,
    auroraSyncBlurbNotRecorded: `Aún no se ha registrado una sincronización para este diseño.`,
    auroraSyncPillCompleted: `Sincronizado`,
    auroraSyncPillFailed: `Error de sincronización`,
    auroraSyncPillInProgress: `Sincronizando`,
    auroraSyncPillNotRecorded: `Sin sincronizar`,
    auroraDesignDetails: `Detalles del Diseño de Aurora`,
    auroraDesignDetailsLoadFailed: `No se pudieron cargar los detalles del Diseño de Aurora.`,
    auroraDesignDetailsLoading: `Cargando los detalles del Diseño de Aurora`,
    auroraDesignRefreshAction: `Actualizar`,
    auroraDesignRefreshFailed: `No se pudo actualizar el Diseño de Aurora. Inténtelo de nuevo.`,
    auroraDesignRefreshInProgress: `Actualizando...`,
    auroraDesignRefreshPrerequisite: `Un administrador debe vincular un Diseño de Aurora antes de que se pueda actualizar.`,
    auroraDesignRefreshStarted: `La actualización del diseño de Aurora ha comenzado. Los datos de la propuesta se están regenerando. El financiamiento se borró solo si no había un Contrato existente y la Solicitud de Préstamo existente (si la hay) aún estaba incompleta.`,
    auroraDesignRefreshWarning: `Actualizar este Diseño de Aurora, de forma manual o automática, actualiza los datos del Diseño desde Aurora. Borra el Producto de Préstamo seleccionado, las selecciones de financiamiento, los incentivos, los programas de préstamo y la Cotización solo cuando no hay un Contrato existente y la Solicitud de Préstamo existente (si la hay) aún está incompleta. Una vez que existe un contrato o la solicitud de préstamo está en espera de aprobación, aprobada o en una etapa posterior, el financiamiento no se modifica. No actualiza la Solicitud de Préstamo existente ni el Contrato existente. Los flujos de trabajo de Órdenes de Cambio específicos del proveedor siguen siendo independientes.`,
    auroraDesignUuid: `UUID`,
    auroraDesignVersionActive: `Activo`,
    auroraDesignVersionAdd: `Agregar versión`,
    auroraDesignVersionAddLabel: `Agregar diseños adicionales de este proyecto de Aurora`,
    auroraDesignVersionAddPlaceholder: `Seleccione un diseño de Aurora`,
    auroraDesignVersionConfirm: `Usar esta versión`,
    auroraDesignVersionConfirmTitle: `¿Usar {{name}} como el Diseño Activo?`,
    auroraDesignVersionLinked: `Se vinculó la Versión del Diseño de Aurora. Los datos de la propuesta se están regenerando desde Aurora.`,
    auroraDesignVersionLinkFailed: `No se pudo vincular la Versión del Diseño de Aurora. Inténtelo de nuevo.`,
    auroraDesignVersionLinking: `Vinculando...`,
    auroraDesignVersionNoneAvailable: `Todos los diseños de este proyecto de Aurora ya son versiones de esta propuesta.`,
    auroraDesignVersionSwitch: `Cambiar`,
    auroraDesignVersionWarning: `El diseño seleccionado se sincroniza desde Aurora y se convierte en el Diseño Activo. Su equipo reemplaza el equipo actual, y se borran el Producto de Préstamo seleccionado, las selecciones de financiamiento, los incentivos, los programas de préstamo y la Cotización.`,
    auroraDesignVersions: `Versiones`,
    auroraDesignVersionsLoadFailed: `No se pudieron cargar los diseños de este proyecto de Aurora.`,
    auroraDesignVersionsLoading: `Cargando las Versiones del Diseño de Aurora`,
    auroraProjectId: `ID del proyecto de Aurora`,
    copyIdentifier: `Copiar {{identifier}}`,
    auroraSynchronizationCompleted: `Completada`,
    auroraSynchronizationCompletedAt: `Sincronización completada`,
    auroraSynchronizationFailed: `Fallida`,
    auroraSynchronizationFailedAt: `Sincronización fallida`,
    auroraSynchronizationInProgress: `En progreso`,
    auroraSynchronizationNotRecorded: `Sin registro`,
    auroraSynchronizationRetryInstruction: `La última sincronización falló. Seleccione Actualizar para volver a intentarlo.`,
    auroraSynchronizationStartedAt: `Sincronización iniciada`,
    auroraSynchronizationStatus: `Estado de sincronización`,
    auroraSynchronizationSyncing: `Sincronizando…`,
    annualOffset: `Compensación Anual`,
    refresh: `Actualizar`,
    refreshing: `Actualizando...`,
    retry: `Reintentar`,
    systemPlacement: `Colocación del Sistema`,
    systemSize: `Tamaño del Sistema`,
    taxStatus: `Estado Fiscal`,
    term: `Término`,
    thisMayTakeSeveralSeconds: `Esto puede tomar varios segundos`,
    toggleTransparency: `Alternar Transparencia`,
    toggleSnap: `Alternar Panel de Ajuste`,
    totalAdders: `Total de Sumadores`,
    totalFee: `% Total de la Comisión del Distribuidor`,
    totalIncentives: `Total de Incentivos`,
    tdu: `Transmisión y Distribución de Energía`,
    travel: `Viaje`,
    treeTrimmingRebate: `Reembolso por poda de árboles`,
    type: `Tipo`,
    uncontained: `Incontenido`,
    updateUtilityInfo: `Actualizar información de la utilidad`,
    upload: `Subir`,
    uploadedFiles: `Archivos Cargados`,
    uploadUtilityBill: `Cargar factura de servicios públicos (opcional)`,
    uploadUtilityBillDesc: `Usado para calcular ahorros`,
    Permissions: `Permisos`,
    usersAdmin: `Gestión de Usuarios`,
    utilityCompany: `Empresa de Servicios Públicos`,
    utilityCompanyAndRate: `Empresa de Servicios Públicos y Tarifa`,
    utilityCompanyAndRateDesc: `Seleccione la empresa de servicios públicos que le gustaría para este sistema.`,
    utilityRate: `Tarifa de Servicios Públicos`,
    warranties: `Garantías`,
    warrantyReserve: `Reserva de garantía`,
    utilityInformation: `Información de Servicios Públicos`,
    fundingPartnerAndEquipment: `Socio Financiero y Equipo`,
    versions: `Versiones`,
    withSolar: `Coste Con Solar`,
    yes: `Sí`,
    your: `Su`,
    zoomIn: `Acercar`,
    zoomOut: `Alejar`,

    PhaseBlock_ThisIsTheLast: `El fase currente es la última fase.`,
    PhaseBlock_DeadEnds: `Los siguientes nodos son finales:`,
    PhaseBlock_EdgesCross: `Hay aristas que se cruzan.`,
    PhaseBlock_NoNodes: `No hay nodos.`,
    PhaseBlock_NoPanels: `No hay paneles.`,
    PhaseBlock_InvalidPanels: `Elimine o ajuste los paneles inválidos (rojos) para continuar.`,
    PhaseBlock_NoAzimuth: `Los siguientes áreas no tienen azimut.`,
    PhaseBlock_IncompleteRoof: `El techo está incompleto.`,
    PhaseBlock_IncompleteEdgeDesignation: `Algunas caras del techo no tienen azimut asignado.`,
    PhaseBlock_ModuleDataRequired: `Se requieren datos del módulo para continuar.`,

    PhaseDesc_ImageSelection: `Selecciona una imagen para comenzar.`,
    PhaseDesc_Outline: `Rastrea los bordes del techo.`,
    PhaseDesc_EdgeDesignation: `Encuentra el azimut de cada cara del techo designando Eaves o Ridges`,
    PhaseDesc_RoofAttributes: `Establece el sombreado y la pendiente de cada cara del techo.`,
    PhaseDesc_PanelPlacement: `Ajusta los paneles más posibles en el techo.`,
    PhaseDesc_PanelActivation: `Elige qué paneles se incluirán en el diseño final.`,

    PhaseName_ImageSelection: `Selección de Imagen`,
    PhaseName_Outline: `Esquema`,
    PhaseName_EdgeDesignation: `Designación de Bordes`,
    PhaseName_RoofAttributes: `Atributos del Techo`,
    PhaseName_PanelPlacement: `Colocación de Paneles`,
    PhaseName_PanelActivation: `Activación de Paneles`,

    EdgeType_Eave: `Alero`,
    EdgeType_Hip: `Limatesa`,
    EdgeType_Rake: `Voladizo`,
    EdgeType_Ridge: `Cresta`,
    EdgeType_Valley: `Valle`,

    //Cover
    cover: `Portada`,
    firstYearProduction: `Producción del primer año`,
    inPartnershipWith: `En alianza con`,
    powurProposal: `Propuesta de powur`,
    presentedBy: `Presentado por`,
    utilitySavings: `Ahorros de servicios públicos`,
    whyGoSolar: `¿Por qué optar por la energía solar?`,
    yourSolarDesign: ` Su diseño solar`,

    //Why Go Solar?
    controlYourEnergyCosts: `Controle sus costos de energía`,
    whyGoSolarDes: `Más personas están eligiendo la energía solar en el hogar que nunca, porque simplemente tiene sentido. Hay innumerables razones para elegir la energía solar, ¡pero solo le daremos algunas!`,
    whyGoSolarHeading: `La verdadera pregunta es ¿por qué no hacerlo?`,
    controlYourEnergyCostsDes: `El precio promedio de los servicios públicos casi se ha duplicado desde 2003. Con la energía solar, ya no está alquilando energía de la empresa local de servicios públicos. En cambio, está produciendo energía solar directamente en su techo. Esto no solo le permite ahorrar dinero en sus costos de energía, sino que también le permite asegurar tarifas predecibles y proteger a su familia del aumento de las tarifas de energía.`,
    addValueToYourHome: `Agrega valor a su hogar`,
    addValueToYourHomeDes: `La energía solar es una de las mejoras para el hogar más inteligentes que puede hacer porque le ahorra dinero a corto plazo Y agrega un valor considerable a largo plazo a su hogar. Los estudios muestran que las casas con energía solar se venden un 20 % más rápido y por un 4-6 % más en promedio. Piénselo de esta manera: ¡le está dando a un posible futuro comprador facturas de energía más bajas sin problemas!`,
    makeADifference: `Marcar la diferencia en el mundo`,
    makeADifferenceDes: `Elegir energía limpia y confiable justo en su techo es una de las elecciones más fáciles pero más importantes que puede hacer como familia para ser parte de la solución cuando se trata de nuestro medio ambiente. Reducirá sustancialmente su huella de carbono, lo que reduce la contaminación y ayuda a aliviar la presión sobre una infraestructura de servicios públicos obsoleta.`,

    //Why Choose Us
    whyChooseUsHeader: `Nos sentiríamos honrados si nos eligiera`,
    whyChooseUsSubHeader: `Usted tiene muchas opciones`,
    whyChooseUsDes: `Si nos permite un pequeño momento de presunción humilde, nos gustaría mostrarle algunas de las razones por las que Powur es la compañía solar de más rápido crecimiento en Estados Unidos. Estos son algunos elogios bastante impresionantes, pero lo que más nos enorgullece es nuestra calificación de 5 estrellas porque significa que las personas como usted están felices con lo que hemos hecho por ellos.`,
    experience: `Experiencia`,
    experienceDes: `Más de las 20,000 Instalaciones exitosas`,
    growth: `Crecimiento`,
    growthDes: `Compañía residencial de más rápido crecimiento en Estados Unidos`,
    stability: `Estabilidad`,
    stabilityDes: `Dos rondas consecutivas de crowdfunding sin precedentes`,
    satisfaction: `Satisfacción`,
    satisfactionDes: `Calificación de 5 estrellas en Yelp y A+ en BBB`,
    peace: `Tranquilidad`,
    peaceDes: `Garantía de 30 años líder en la industria`,
    impact: `Impacto`,
    impactDes: `Apoya proyectos de reforestación en la selva amazónica`,
    community: `Comunidad`,
    communityDes: `Empresa propiedad de empleados y miembros`,
    responsibility: `Responsabilidad`,
    responsibilityDes: `Compensaciones de carbono para el 100% del impacto corporativo`,

    //What We Promise
    whatWePromiseHeader: `Esto es lo que prometemos a nuestros clientes`,
    whatWePromiseSubHeader: `Como dijimos, todo se trata de ti.`,
    whatWePromiseDes: `Cuando elige Powur, puede estar seguro de que está obteniendo una solución totalmente personalizada para su hogar. Powur es único en la industria solar porque somos una plataforma solar que reúne los mejores productos, servicios, opciones y profesionales para su hogar.”:
    “Socios de instalación.`,
    whatOurPlatformModelMeans: `Qué significa para usted nuestro modelo de plataforma`,
    whatWePromiseCustomize: {
      text: `Nuestras amplias opciones de financiamiento y equipos significan una`,

      boldText: `solución totalmente personalizada.`,
    },

    whatWePromiseValue: {
      text1: `Nuestro modelo operativo de escala y bajo costo significa soluciones asequibles y `,
      boldText: `el mejor valor`,
      text2: `para usted.`,
    },
    whatWePromisePartner: {
      text1: `Nuestro equipo de socios de instalación examinados y certificados significa que usted obtiene `,

      boldText: `experiencia `,
      text2: `y calidad local.`,
    },

    whatWePromisePersonal: {
      text1: `Nuestro modelo de vendedor independiente significa que obtiene una `,
      boldText: `guía personal `,
      text2: `a través del proceso de descubrimiento.`,
    },

    whatWePromisePhone: {
      text1: `Nuestra plataforma de comunicaciones de clase mundial significa que obtiene un `,
      boldText: `servicio premium`,
      text2: `a través del proceso de implementación.`,
    },

    whatWePromiseMedal: {
      text1: `Nuestra garantía de 30 años líder en la`,
      boldText: `tendrá tranquilidad`,
      text2: `durante la vida útil de su sistema Powur.`,
    },

    whatWePromiseWorld: {
      text: `Nuestra comunidad basada en la misión significa que usted puede contribuir a un`,
      boldText: `impacto local y global significativo.`,
    },

    whatWePromiseConnect: {
      text1: `Nuestro programa de embajadores significa que usted obtiene`,
      boldText: `recompensas financieras`,
      text2: `cuando recomienda a otros la energía solar.`,
    },

    //Design For
    designedFor: `Diseñado para`,
    yourPowurSystem: `Su Sistema Solar Powur`,
    auroraDesign: `Diseño de Aurora`,
    auroraDesignManaged: `El diseño de este sistema se gestiona en Aurora.`,
    estimatedUsage: `Uso Estimado`,
    estimatedUsageDes: `Su uso estimado está determinado por su consumo futuro y puede variar según los cambios en su uso y/o cambios en su clima.`,
    editDesign: `Editar Diseño`,
    editInAurora: `Editar en Aurora`,

    //System Production
    systemProductionSubHeading: `¿Cuánto producirá su sistema?`,
    systemProductionHeading: `Estimación de producción de su sistema`,
    systemProductionDes: `Este gráfico muestra la cantidad de energía que usa en su hogar en comparación con la cantidad estimada de energía que producirá su sistema solar Powur`,
    offsetStatDes: `La cantidad estimada de su consumo compensado por su sistema solar`,
    productionStatDes: `Producción anual estimada de su sistema solar`,

    //Payment Summary
    autopayNotice: `APR es 0.50% más alto sin Autopay`,
    cash: `Efectivo`,
    cashPayment: `pago en efectivo`,
    loanAmount: `Monto del préstamo`,
    netSystemCost: `Costo neto del sistema`,
    preQualify: `Precalificar`,
    qualify: `Calificar`,
    residentialTaxCredit: `Crédito fiscal residencial de energía renovable`,
    sendContractDocuments: `Enviar documentos del contrato`,
    publicQualificationApply: `Solicitar ahora`,
    publicQualificationAskConsultant: `Su consultor le guiará en esta solicitud.`,
    publicQualificationContinue: `Continuar solicitud`,
    publicQualificationNoUrl: `No pudimos abrir la solicitud del prestamista. Inténtelo de nuevo.`,
    publicQualificationNotSubmitted: `El prestamista no aceptó esta solicitud. Su consultor puede ayudarle desde aquí.`,
    publicQualificationOpening: `Abriendo…`,
    publicQualificationSubmitted: `Su solicitud ha sido enviada.`,
    publicQualificationSubmittedDetail: `Su consultor le informará sobre el resultado. No necesita enviarla de nuevo.`,
    publicQualificationUnavailable: `Las opciones de financiamiento no están disponibles en este momento. Recargue la página.`,
    totalProjectCost: `Costo total del proyecto`,

    //Credit Application
    addCoApplicant: `Agregar un Co-Solicitante`,
    annualIncome: `Ingresos Anuales`,
    dob: `Fecha de Nacimiento`,
    citizenshipStatus: `Estado de Ciudadanía`,
    city: `Ciudad`,
    coApplicant: `Co-solicitante`,
    creditAppHeader: `Solicitud de Crédito`,
    enfinApplicationLoadingTitle: `Conectándote con EnFin…`,
    enfinApplicationLoadingBody: `Tu solicitud de crédito se está cargando. Esto puede tardar unos segundos.`,
    emailAddress: `Dirección de correo electrónico`,
    employer: `Empleador`,
    employmentDuration: `Duración del empleo (años)`,
    employmentStatus: `Situación Laboral`,
    homeOccupancy: `Ocupación del Hogar`,
    homeOwnership: `Propiedad de la Vivienda`,
    less: `menos`,
    loadingMessage: `cargando`,
    middleName: `segundo nombre o inicial`,
    mosaicHeader: `Precalificar de Crédito`,
    mosaicTerms: `Acepto los términos y condiciones enumerados anteriormente.`,
    mosaicSecondaryTerms: `Acepto los términos y condiciones enumerados anteriormente.`,
    occupation: `Ocupación`,
    otherIncome: `Otros ingresos del hogar (anual)`,
    personalIncome: `Ingresos Personales (anuales)`,
    phoneType: `Tipo de Telefono`,
    privacyPolicy: `Política de Privacidad`,
    readMore: `Leer mas`,
    secondaryApplicant: `Solicitante Secundario`,
    ssn: `Últimos 4 del número de seguro social`,
    fullSsn: `SSN`,
    state: `Estado`,
    street: `Calle`,
    zip: `Código Postal`,

    //Savings Over Time
    savingsOverTimeSubHeader: `¿Cuánto puede ahorrar?`,
    savingsOverTimeHeader: { text1: `Ahorre`, text2: `en 25 años` },
    monthlyBillComputeNote: `Incluye la base garantizada del nodo de cómputo; vea Ahorros de servicios públicos`,
    savingsOverTimeComputeNote: `Incluye la base garantizada del nodo de cómputo de \${{monthly}} al mes en cada uno de {{years}} años. El bono de la red nunca se cuenta.`,
    cashLegendItemSystemCost: `Costo del sistema`,
    cashLegendItemCumulativeUtilityCostWithoutSolar: `Costo acumulado de la utilidad sin solar`,
    financedLegendItemWithoutSolar: `Mensual factura de servicios públicos sin energía solar`,
    financedLegendItemWithSolar: `Mensual factura de servicios públicos con energía solar`,
    financedLegendItemCost: `Mensual costo del sistema sola`,
    newSolarPayment: `Nuevo pago solar`,
    currentUtilityPayment: `Pago de servicios públicos actual`,
    newUtilityPayment: `Nuevo pago de servicios públicos`,
    availableIncentives: `Incentivos disponibles`,
    costOfDoingNothing: `Costo de no hacer nada`,
    totalSavings: `Ahorro total a 25 años`,

    //We influence change
    influenceChangeSubHeader: `Por que Powur?`,
    influenceChange: {
      text1: ``,
      highlightText: `Influimos`,
      text2: `en el cambio`,
    },
    weInfluenceChange: `Influimos en el cambio`,
    slideOneHeader: `Nuestra misión es acelerar la adopción de energía limpia en todo el mundo`,
    slideOneDes: `Cada cliente hace una diferencia tangible, una diferencia medible en el camino hacia un futuro de energía limpia`,
    slideTwoHeader: `Estamos construyendo activamente la economía solar y de energía limpia en Estados Unidos`,
    slideTwoDes: `Como Corporación B y Corporación B Certificada, Powur toma muy en serio nuestra responsabilidad con nuestras comunidades. Estas distinciones significan que hemos logrado una puntuación de impacto B independiente que representa un desempeño social y ambiental tangible y que nuestra estructura de gobierno corporativo representa nuestro compromiso con todas las partes interesadas más allá de las ganancias.`,
    ecologiDes: `Fuerza laboral climáticamente positiva a través de la asociación Ecologi`,
    logoOneDes: `Empoderando a los pueblos indígenas en la Amazonía a través de cada proyecto`,
    logoTwoDes: `Apoyo a familias individuales con vivienda y energía limpia`,
    slideThreeHeader: `Cada año, Powur produce un Informe de impacto del año anterior. Estos son algunos de los aspectos más destacados del informe de 2022`,
    slideThreeInstalls: `Número de instalaciones de 2022`,
    installationsTotal: `Instalaciones Totales en 2022`,
    kilowattsInstalled: `Kilovatios Instalados en 2022`,
    customerSavings: `Ahorros estimados de por vida de los clientes a partir de las instalaciones de 2022`,
    savedCO2: `Toneladas métricas estimadas de CO2 ahorradas de por vida de las instalaciones de 2022`,
    slideFourHeader: `Esto es a lo que eso equivale`,
    vehiclesRemoved: `Vehículos de pasajeros retirados de la carretera durante un año`,
    gasolineNotConsumed: `Galones de gasolina no consumidos`,
    wasteRecycled: `Bolsas de basura de residuos reciclados en lugar de ser llevados al vertedero`,
    seedlingsGrown: `Plántulas de árboles cultivadas durante 10 años`,

    //How does solar work
    whatIsSolarSubHeading: `¿Cómo funciona la energía solar?`,
    whatIsSolarHeading: {
      text1: `Energía limpia del sol justo en`,
      highlightText: `su azotea`,
      text2: ``,
    },
    whatIsSolarDes: `En pocas palabras, la energía solar utiliza la luz del sol, abundante y fácilmente disponible, para alimentar su hogar. Estos son los conceptos básicos de cómo funciona y los componentes que necesita para un sistema solar.`,
    panelsDes: `Sus paneles absorben la luz del sol en capas de silicio para crear una corriente eléctrica.`,
    inverterDes: `Un inversor convierte la electricidad de sus paneles de electricidad de “corriente continua” (CC) (lo que significa que fluye en una sola dirección) a electricidad de “corriente alterna” (CA), que es lo que usamos en nuestros hogares y negocios.`,
    meterDes: `Su medidor lo mantiene conectado a la red, monitorea el flujo de electricidad y rastrea la cantidad de energía que usa. En áreas donde la medición neta está disponible, su electricidad puede fluir hacia su hogar o de regreso a la red.`,
    gridConnection: `Conexión a la red y medición neta`,
    gridConnectionDes: `Muchas áreas brindan lo que se llama medición neta, lo que significa que cualquier exceso de energía que produzca en su azotea se puede vender a la red.`,
    storageDes: `Las soluciones de almacenamiento son cada vez más atractivas para los propietarios de viviendas que desean almacenar el exceso de energía para su uso posterior.`,

    //The Steps
    stepsHeader: {
      text1: `Un proceso simple y`,
      highlightText: `sin`,
      text2: `complicaciones`,
    },
    stepsDes: `Una vez que elige seguir adelante con Powur, está un paso más cerca de controlar sus costos de energía. Tendrá un gerente de proyecto dedicado asignado a su proyecto y nuestra plataforma lo mantendrá al tanto de cada paso del camino. Cada mercado es diferente, pero generalmente toma entre 3 y 16 semanas para que sus paneles se instalen y la energía fluya hacia su hogar.`,
    projKickOff: `Comienzo del proyecto`,
    projKickOffTitle: `Contratos firmados y llamada de bienvenida`,
    projKickOffDes: `El proceso comienza con el Contrato de Mejoramiento de Vivienda el cual puede firmar con la ayuda de su Vendedor. Una vez que esté completo, reciba una llamada de bienvenida de nuestro equipo de éxito del proyecto para responder cualquier pregunta que pueda tener y repasar algunos detalles de su proyecto.`,
    stageOne: `Etapa 1 • 1-2 semanas`,
    stageOneTitle: `Evaluación del Sitio`,
    stageTwo: `Etapa 2 • 1-2 semanas`,
    stageTwoTitle: `Diseño`,
    stageThree: `Etapa 3 • 4-6 semanas`,
    stageThreeTitle: `Permisos`,
    stageFour: `Etapa 4 • 4-6 semanas`,
    stageFourTitle: `Instalación`,
    stageFive: `Etapa 5 • 1 semana`,
    stageFiveTitle: `Inspección`,
    stageSix: `Etapa 6 • 4-6 semanas`,
    stageSixTitle: `¡Encendido!`,
    fundingType: `Tipo de Financiamiento`,
    productGroup: `Grupo de Productos`,
    fundingSelection: `Selección de Financiamiento`,

    //System Components
    yourSystemComponents: `Componentes de su sistema`,

    //AI Compute
    aiCompute: `Cómputo de IA`,
    aiComputeSlide: {
      eyebrow: `Complemento opcional · Nodo de cómputo`,
      title: `Ingresos por cómputo que pueden`,
      titleHighlight: `ayudarle a pagar sus facturas.`,
      description: `Aloje un nodo de cómputo de Vendor en su hogar. Vendor le paga una base fija de {{base}} cada mes durante {{years}} años, más un bono de la red de hasta {{bonusCap}} cuando la red lo genera.`,
      descriptionNoFigures: `Aloje un nodo de cómputo de Vendor en su hogar. Vendor le paga una base fija cada mes, más un bono de la red cuando la red lo genera.`,
      defaultNodeName: `Nodo de cómputo`,
      nodeImageAlt: `Nodo de cómputo de Vendor montado en la pared`,
      nodeEyebrow: `Nodo de cómputo Vendor®`,
      partnership: `En colaboración con Vendor®`,
      planPill: `Plan de alojamiento {{plan}}`,
      plans: {
        core: `Core`,
        plus: `Plus`,
        max: `Max`,
      },
      howItWorksEyebrow: `Cómo funciona`,
      howItWorks: {
        install: {
          title: `Lo instalamos en el interior`,
          body: `Un nodo montado en la pared de su garaje o cuarto de servicio. Se conecta a un tomacorriente estándar, como una computadora, y a la conexión de internet de su hogar.`,
        },
        online: {
          title: `Usted lo mantiene en línea`,
          body: `Manténgalo encendido y con una conexión a internet de 1 Gbps. Vendor lo supervisa y se encarga de cada reparación y mejora.`,
        },
        payout: {
          title: `Recibe pagos mensuales`,
          body: `Una base mensual fija más un bono de la red hasta el límite de su plan, pagados a más tardar el día 15 del mes siguiente.`,
        },
      },
      term: `Plazo de {{years}} años desde la activación · Vendor mantiene y mejora el nodo sin costo`,
      termNoFigures: `El plazo comienza con la activación · Vendor mantiene y mejora el nodo sin costo`,
      story: {
        eyebrow: `¿Qué es un nodo de cómputo?`,
        title: `Una supercomputadora en su hogar, y usted recibe una recompensa por alojarla.`,
        intro: `La demanda de capacidad de cómputo crece más rápido de lo que se puede construir. Su nodo de cómputo de Vendor es una supercomputadora que vende su tiempo de cómputo a clientes como empresas de IA, laboratorios de investigación y más. Vendor es dueño del nodo, encuentra a los clientes y le paga cada mes por alojarlo.`,
        flowLabel: `Cómo se mueve el dinero`,
        flow: {
          customers: {
            who: `Clientes de cómputo`,
            what: `Empresas de IA, laboratorios de investigación y más le pagan a Vendor por tiempo de cómputo`,
            arrow: `compran cómputo`,
          },
          vendor: {
            who: `Vendor`,
            what: `Vende la capacidad y reparte el trabajo en su red de nodos de cómputo`,
            arrow: `envía trabajo`,
          },
          node: {
            who: `Su nodo de cómputo`,
            what: `Hace el trabajo con la electricidad y el internet de su hogar`,
            arrow: `le paga cada mes`,
          },
          you: {
            who: `Usted`,
            what: `Una base fija cada mes, más una parte de las ganancias de la red hasta el límite de su plan`,
          },
        },
        questions: {
          why: {
            label: `Por qué`,
            title: `El mundo necesita más capacidad de cómputo.`,
            body: `La demanda de cómputo supera la oferta. Alojar un nodo pone más capacidad a trabajar y le paga a usted por darle un lugar donde funcionar.`,
          },
          what: {
            label: `Qué hace`,
            title: `Vende tiempo de cómputo a los clientes de Vendor.`,
            body: `Empresas de IA, laboratorios de investigación y otros clientes compran tiempo en la red. Usted no tiene que administrar nada; Vendor encuentra el trabajo y mantiene el nodo funcionando.`,
          },
          who: {
            label: `Quién lo paga`,
            title: `Vendor es dueño del nodo y paga su mantenimiento.`,
            body: `Sin compra, arrendamiento ni préstamo. Vendor paga el mantenimiento, las reparaciones, las mejoras y los reemplazos durante 30 años. Usted aporta el espacio, la electricidad y una conexión a internet de 1 Gbps.`,
          },
          earn: {
            label: `Cómo gana`,
            title: `Una base fija, más una recompensa cuando a la red le va bien.`,
            body: `La base se paga cada mes, esté ocupado o no su nodo. Cuando la red genera un excedente, la mitad se reparte entre los anfitriones como bono, hasta el límite mensual de su plan.`,
          },
        },
      },
      bonus: {
        eyebrow: `Cómo funciona el bono de la red`,
        lead: `Piense en el bono como una participación en las ganancias. Su nodo es uno de muchos en la red de Vendor. Cuando la red genera más dinero de lo que cuesta operarla, Vendor comparte la mitad del excedente con sus anfitriones. Los planes más grandes reciben una parte mayor, hasta el límite de su plan.`,
        strong: {
          label: `Un mes fuerte`,
          title: `La red gana más de lo que cuesta.`,
          body: `La mitad del excedente va a los anfitriones, así que usted recibe su base más un bono.`,
        },
        slow: {
          label: `Un mes flojo`,
          title: `La red solo cubre sus costos.`,
          body: `No hay excedente que compartir, así que ese mes no hay bono. Su base se paga de todos modos.`,
        },
        notes: {
          network: {
            title: `Depende de toda la red.`,
            body: `Qué tan ocupado esté su propio nodo no cambia su bono.`,
          },
          carryOver: {
            title: `Los meses flojos no se arrastran.`,
            body: `Un mes flojo nunca reduce uno posterior.`,
          },
          statement: {
            title: `Puede ver las cuentas.`,
            body: `Su estado de cuenta mensual muestra lo que ganó la red, sus costos y su parte.`,
          },
        },
        payBase: `Base de {{amount}}`,
        payBonusUpTo: `+ bono de hasta {{amount}}`,
        payBaseNoFigures: `Su base`,
        payBonusUpToNoFigures: `+ bono hasta el límite de su plan`,
        payBonusZero: `+ bono de $0`,
      },
      ledger: {
        eyebrow: `Su pago mensual por alojamiento`,
        plan: `Plan de alojamiento`,
        planNote: `según su anexo de alojamiento`,
        base: `Base mensual fija`,
        baseNote: `desde la activación, cada mes del plazo de {{years}} años`,
        guaranteed: `Garantizada`,
        bonus: `+ Bono por rendimiento de la red`,
        bonusNote: `lo máximo que puede ser · puede ser $0`,
        varies: `Varía`,
        nodeElectricity: `Electricidad del nodo`,
        nodeElectricityNote: `ahorros modelados con un 90% de utilización`,
        nodeElectricityValue: `{{kwh}} kWh/año`,
        total: `Su pago mensual`,
        totalNote: `base + bono, antes de impuestos`,
        upTo: `hasta`,
        legendBase: `Base garantizada de {{amount}}`,
        legendBonus: `Bono de hasta {{amount}}`,
      },
      share: {
        eyebrow: `A dónde puede ir su pago · ilustrativo`,
        text1: `Hasta`,
        text2: ` (una base de {{base}} más el bono), junto a su factura de servicios públicos estimada de`,
        text3: `después de la energía solar.`,
        costText2: ` (una base de {{base}} más el bono), junto a su factura de servicios públicos y su pago solar estimados:`,
        costText3: `en total.`,
        costBreakdown: `{{bill}} de factura de servicios públicos después de la energía solar + {{payment}} de pago solar`,
        perMonth: `{{amount}}/mes`,
        coveredBill: `Para su factura est.`,
        coveredCost: `Para su factura + pago`,
        leftOver: `Sobrante de la base`,
        bonusUpTo: `Bono, hasta`,
        note: `Es una ilustración. Puede autorizar a Vendor a pagar parte o la totalidad de su pago a sus facturas de electricidad, internet, solar, financiamiento o batería; lo que paga a una factura sale del mismo pago, no se suma a él. Solo la base está garantizada; el bono puede ser $0.`,
      },
      stats: {
        monthly: `Pago mensual`,
        upTo: `hasta {{amount}}`,
        monthlyNote: `{{base}} garantizados + bono de hasta {{bonusCap}}`,
        termTotal: `Total en {{years}} años`,
        termTotalNote: `{{amount}} de ello garantizados`,
        term: `Plazo`,
        termValue: `{{years}} años`,
        termNote: `desde la activación · mejoras sin costo`,
      },
      app: {
        eyebrow: `Sus ganancias a la vista`,
        text: `Consulte su base, su bono y sus pagos en la aplicación de Vendor.`,
        imageAlt: `Aplicación de Vendor con las ganancias por cómputo`,
      },
      faqEyebrow: `Preguntas frecuentes de los propietarios`,
      faq: {
        guaranteed: {
          question: `¿Los ingresos están garantizados?`,
          answer: `La base mensual está garantizada durante el plazo de 30 años desde la activación, esté ocupado o no su nodo. El bono de la red, hasta el límite mensual de su plan, depende de lo que cobre toda la red de Vendor y puede ser $0. Los pagos pueden estar sujetos a impuestos.`,
        },
        bonusThreshold: {
          question: `¿El bono se activa con cierto nivel de utilización?`,
          answer: `No. No hay un umbral ni una tarifa por hora. El bono crece con lo que toda la red gana por encima de sus costos, así que los meses de más actividad suelen pagar más, pero incluso un mes de mucha actividad puede pagar $0 si los costos son altos.`,
        },
        payment: {
          question: `¿Cómo y cuándo me pagan?`,
          answer: `A más tardar el día 15 de cada mes, por el mes anterior. Recíbalo en efectivo o autorice a Vendor a pagar parte o la totalidad a sus facturas de electricidad, internet, solar, financiamiento o batería y a pagarle a usted el resto.`,
        },
        ownership: {
          question: `¿Quién es dueño del nodo y quién le da mantenimiento?`,
          answer: `Vendor es dueño del nodo y se encarga de todo el mantenimiento, las reparaciones, las mejoras y los reemplazos durante los 30 años, sin costo para usted. Las mejoras no cambian su base ni el límite de su bono.`,
        },
        cancel: {
          question: `¿Puedo dejar de alojarlo?`,
          answer: `El acuerdo dura 30 años y no incluye un derecho a cancelar por conveniencia. Usted conserva los derechos de cancelación que le otorgue la ley, y usted y Vendor pueden acordar por escrito terminarlo.`,
        },
        vendorStops: {
          question: `¿Qué pasa si Vendor deja de operar?`,
          answer: `Si Vendor deja de prestar el servicio de forma permanente antes de que termine el plazo, paga el valor justo de mercado tasado del nodo para el financiamiento de su sistema solar o batería.`,
        },
        electricity: {
          question: `¿Quién paga su electricidad?`,
          answer: `Funciona con la electricidad de su hogar y necesita una conexión a internet de 1 Gbps. Esa electricidad ya está incluida en su estimación de ahorros, y la base fija es el aporte de Vendor a esos costos.`,
        },
      },
      unavailable: {
        loading: `Cargando la estimación de ingresos…`,
        withheld: `Las estimaciones de ingresos se están actualizando`,
        failed: `Estimación de ingresos no disponible`,
      },
      disclosure: {
        intro: `Cifras ilustrativas basadas en el Acuerdo de Alojamiento de Vendor, Revisión 2.10.`,
        plan: `El Plan de alojamiento {{plan}} paga una base mensual fija de {{base}} desde la activación durante el plazo de servicio de {{years}} años; el bono variable por rendimiento de la red tiene un límite de {{bonusCap}} al mes, se calcula con los ingresos cobrados por toda la red según la Sección 2.2 y puede ser $0.`,
        planNoFigures: `Cada Plan de alojamiento paga una base mensual fija desde la activación durante el plazo de servicio; el bono variable por rendimiento de la red tiene un límite según el plan, se calcula con los ingresos cobrados por toda la red según la Sección 2.2 y puede ser $0.`,
        capNotEstimate: `Los totales que incluyen el bono muestran su límite, no una estimación.`,
        savingsInclude: `Su estimación de ahorros cuenta solo la base, en cada uno de sus {{years}} años de ahorros.`,
        electricity: `La electricidad del nodo se modela con un 90% de utilización y está incluida en su estimación de ahorros. Los pagos pueden estar sujetos a impuestos; consulte a un asesor fiscal.`,
      },
    },

    //Powur Care
    powurCare: `Powur Care`,
    powurCareSlide: {
      title: `Proteja su sistema solar con`,
      titleHighlight: `cobertura de {{years}} años.`,
      description: `Protección líder en la industria para cada componente que instalamos: piezas, mano de obra y monitoreo, a cargo de Powur durante las próximas tres décadas.`,
      badgeAlt: `Insignia de garantía de {{years}} años de Powur Care`,
      coveragePeriodEyebrow: `Período de cobertura`,
      coveragePeriod: `Tres décadas de protección total, monitoreada`,
      coveragePeriodEnd: `de principio a fin.`,
      benefitsEyebrow: `Protección líder en la industria`,
      yearsPill: `{{years}} años`,
      benefits: {
        partsAndLabor: {
          title: `Piezas y mano de obra cubiertas al 100%`,
          note: `Cobertura integral del equipo Y del trabajo en el sitio.`,
        },
        noDeductible: {
          title: `Deducible de $0`,
          note: `Nunca se cobra por presentar un reclamo.`,
        },
        nationwide: {
          title: `Cobertura en todo EE. UU.`,
          note: `Cobertura continua si se muda a otro estado.`,
        },
        transferable: {
          title: `Titularidad transferible`,
          note: `Aumenta el valor de reventa: la cobertura se transfiere con la vivienda.`,
        },
        powurBacked: {
          title: `La confianza del respaldo de Powur`,
          note: `Respaldada por Powur, no por un intermediario de garantías externo.`,
        },
        inHouseClaims: {
          title: `Reclamos gestionados internamente`,
          note: `Un número, un equipo, sin cadena de escalamiento.`,
        },
      },
      truckRollFee: `Es posible que se cobre una tarifa de diagnóstico inicial por el desplazamiento del técnico en la primera visita de servicio. Esta tarifa se`,
      truckRollFeeRefunded: `reembolsa en su totalidad`,
      truckRollFeeEnd: `si se determina que el problema reportado está cubierto por esta garantía.`,
      coveredEyebrow: `Lo que cubrimos`,
      systemsPill: `{{total}} sistemas`,
      systems: {
        panels: `Paneles solares`,
        inverters: `Microinversores`,
        battery: `Almacenamiento en batería`,
        racking: `Sistema de montaje`,
        roof: `Penetraciones en el techo`,
        workmanship: `Mano de obra de instalación`,
      },
      limitedTerms: {
        battery: {
          before: `La cobertura del almacenamiento de energía (batería) se proporciona por un plazo de`,
          term: `veinticinco (25) años`,
          after: `, además de —y no en sustitución de— cualquier garantía aplicable del fabricante.`,
        },
        roof: {
          before: `La cobertura de las penetraciones en el techo se proporciona por un plazo de`,
          term: `quince (15) años`,
          after: `, además de —y no en sustitución de— cualquier garantía aplicable del contratista o del fabricante.`,
        },
      },
      footer: `La cobertura comienza el día de Powur On y continúa sin interrupción durante {{years}} años. Consulte los términos completos en`,
    },

    // Contract Signing
    send: `Enviar`,
    sending: `Enviando`,
    sendNew: `Enviar nuevo`,
    noContracts: `No se han enviado contratos.`,
    contractCannotBeSent: `El contrato no puede ser enviado`,
    designNeedsCorrected: `El diseño no puede ser instalado: el proyecto no puede ser instalado tal como está diseñado. Edite el diseño para cumplir con los requisitos.`,
    dateSent: `Enviado a`,
    dateSigned: `Firmado en`,
    totalCost: `Coste Total`,

    ...regressionWarnings,
    ...toolDescriptions,
    ...toolLabels,

    ...utilityCompanyAdminTable,

    ...poisonMessages,

    ...brochureSections,
    ...systemSummarySlide,
    ...monthlyBillSlideDisclaimers,
    ...utilitySavingsSlides,

    ...shareProposalStep,

    //Drawer
    escalate: `Escalado`,
    escalationDesc: `Proporcione cualquier detalle adicional o relevante que sea crítico para que su escalamiento se realice correctamente. Se lo mas especifico que puedas:`,
    escalationPlaceholder: `Proporcione detalles adicionales relacionados con su solicitud de escalamiento. (Máximo 1000 caracteres)`,
    notes: `Notas`,
    proposalDetails: `Detalles de la Propuesta`,
    requestEscalation: `Solicitar escalado`,
    thereAreNoNotesForThisDesign: `No hay notas para este diseño`,
    tickets: `Entradas`,
    ticketUrl: `URL del ticket`,

    mortgagePayment: `Pago de Hipoteca`,
    propertyOwner: `Propietario de la Propiedad`,
    propertyType: `Tipo de Propiedad`,
    residencyType: `Tipo de Residencia`,
    reverseMortgage: `Hipoteca Revertida`,
    spanishSpeaker: `Habla Español`,
    yearsAtAddress: `Años en la Dirección Actual`,

    poisonedDesign: `Este diseño no es válido y no se puede vender.`,
  },
}

export default es
